import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 15000,
    headers: { "Content-Type": "application/json" },
});

export async function submitInquiry(payload) {
    const { data } = await api.post("/inquiries", payload);
    return data;
}
